import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { fetchPosts, fetchEvents } from "../services/homeApi";

// ─── Home sub-components ───
import Hero from "../components/Home/Hero";
import About from "../components/Home/About";
import ConsultasjonTeaser from "../components/Home/ConsultasjonTeaser";
import Scholar from "../components/Home/Scholar";
import Events from "../components/Home/Events";
import Footer from "../components/Home/Footer";

import "../components/Home/Home.css";

function Home() {
  const { user } = useAuth();
  const [posts, setPosts] = useState([]);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    fetchPosts().then(setPosts).catch(console.error);
    fetchEvents().then(setEvents).catch(console.error);
  }, []);

  return (
    <div className="d-flex flex-column min-vh-100">
      <Hero />
      <About />
      <ConsultasjonTeaser posts={posts} />
      <Scholar />
      <Events events={events} />
      <Footer />
    </div>
  );
}

export default Home;
